<div class="cf-dlg" style="min-width:460px">

  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>{{ data.isCopy ? 'content_copy' : 'open_with' }}</mat-icon></div>
    <div style="flex:1;min-width:0">
      <h2 class="cf-dlg-title">{{ data.isCopy ? 'Copiar en…' : 'Mover a…' }}</h2>
      <p class="cf-dlg-subtitle">Selecciona la carpeta de destino</p>
    </div>
    <button mat-icon-button [mat-dialog-close] aria-label="Cerrar" style="flex-shrink:0;color:var(--cf-text-muted)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Breadcrumb -->
  <div style="padding:10px 24px;border-bottom:1px solid var(--cf-border);background:var(--cf-bg)">
    <nav style="display:flex;align-items:center;flex-wrap:wrap;gap:2px">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last; trackBy: trackByIndex">
        <span *ngIf="!last"
          style="font-size:13px;color:var(--cf-brand-dark);cursor:pointer;font-weight:500"
          (click)="navigateTo(crumb)">{{ crumb.label }}</span>
        <mat-icon *ngIf="!last" style="font-size:16px;width:16px;height:16px;color:var(--cf-text-muted)">chevron_right</mat-icon>
        <span *ngIf="last" style="font-size:13px;font-weight:600;color:var(--cf-text)">{{ crumb.label }}</span>
      </ng-container>
    </nav>
  </div>

  <!-- Body -->
  <div class="cf-dlg-body" style="padding:8px 0;min-height:200px;max-height:360px">

    <div *ngIf="loading" style="display:flex;justify-content:center;padding:40px">
      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    </div>

    <mat-list *ngIf="!loading" style="padding:0">
      <mat-list-item *ngFor="let dir of dataSource.files; trackBy: trackByIndex" class="fm-dir-item" (click)="goToDirectory(dir)">
        <mat-icon mat-list-icon class="fm-dir-item__icon">folder</mat-icon>
        <span mat-line class="fm-dir-item__name">{{ dir.note || dir.name }}</span>
        <mat-icon class="fm-dir-item__arrow">chevron_right</mat-icon>
      </mat-list-item>

      <div *ngIf="dataSource.files.length === 0"
        style="display:flex;flex-direction:column;align-items:center;padding:40px;color:var(--cf-text-muted);gap:8px">
        <mat-icon style="font-size:40px;width:40px;height:40px;opacity:0.35">folder_open</mat-icon>
        <p style="margin:0;font-size:13px">No hay subcarpetas aquí</p>
      </div>
    </mat-list>

  </div>

  <div class="cf-dlg-footer">
    <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
    <button mat-stroked-button (click)="goBack()" [disabled]="breadcrumbs.length <= 1">
      <mat-icon>arrow_upward</mat-icon> Subir nivel
    </button>
    <button mat-stroked-button (click)="moveToRoot()" *ngIf="breadcrumbs.length > 1">
      <mat-icon>home</mat-icon> {{ data.isCopy ? 'Copiar a la Raíz' : 'Mover a la Raíz' }}
    </button>
    <button mat-flat-button class="cf-dlg-btn-primary" (click)="selectHere()">
      <mat-icon>{{ data.isCopy ? 'content_copy' : 'open_with' }}</mat-icon>
      {{ data.isCopy ? 'Copiar aquí' : 'Mover aquí' }}
    </button>
  </div>

</div>
